import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./AboutUs.css";

function AboutUs() {
  return (
    <>
      <Header />

      <main className="about-page">
        {/* HERO */}
        <section className="about-hero">
          {/* <span className="about-eyebrow">Our Story</span>

          <h1>
            How Aethearia <br />
            Came to Be
          </h1>

          <div className="about-divider">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <p>
            We live in a world that rarely pauses. Aethearia was born from the
            belief that wellbeing should not wait for a holiday or a breakdown.
            It can begin tonight. With intention. With a flame.
          </p> */}
        </section>

        {/* STORY CONTENT */}
        <section className="about-story">
          <div className="about-section">
            <span className="about-eyebrow">Our Story</span>
            <h2>We live in a world that rarely pauses</h2>

            <p>
             Calendars full, minds fuller. Stress has become so ordinary we have stopped noticing it. Mental wellbeing — the quiet kind, the daily kind — is something most of us push to the bottom of the list, somewhere between “I’ll rest when things slow down” and “I’m fine, just busy.” But busy is not fine. And the cost of living entirely in our heads, entirely on the move, shows up quietly — in poor sleep, fraying patience, a persistent sense of being behind.
            </p>


            <p>
              Aethearia was born from the belief that wellbeing should not wait for a holiday or a breakdown. It can begin tonight. With intention. With a flame.
            </p>
          </div>

          {/* <div className="about-break">— &nbsp; — &nbsp; —</div> */}

          <div className="about-section">
            <h2>But not just any candle</h2>

            <p>
              Walk into any home goods store and you will find shelves lined
              with candles — most of them pretty, many of them fragrant, almost
              all of them built around synthetic scents designed to smell
              pleasant and little more. They fill a room. They do not change it.
            </p>

            <p>
              Aethearia is different, and the difference is not aesthetic — it
              is scientific.
            </p>

            <p>
              Our candles are crafted with carefully selected essential oils, each chosen not just for how they smell, but for what they do. Essential oils are not fragrance for the sake of fragrance. They are complex botanical compounds with documented effects on the human nervous system. Lavender has been shown to reduce cortisol and promote calm. Eucalyptus clears the mind and opens the breath. Frankincense slows neural activity, deepening states of meditation and stillness. Bergamot lifts mood. Cedarwood grounds and settles anxiety. This is aromatherapy in its truest sense — not a wellness trend, but a science with centuries of evidence behind it.
            </p>


            {/* <p className="about-highlight"> */}
              <p>
              When you light an Aethearia candle, you are not just scenting a
              room. You are actively shaping how you feel in it.
            </p>
          </div>

          {/* <div className="about-break">— &nbsp; — &nbsp; —</div> */}

          <div className="about-section">
            <h2>This understanding is not new to India</h2>

            <p>
             Long before modern science gave us the vocabulary, our culture knew that flame and fragrance carried power. Camphor to cleanse and energise. Sandalwood to quiet a restless mind. Incense to mark the transition from the ordinary to the sacred. These were not decorative choices — they were intentional acts of emotional and spiritual care, practised daily, across generations.
            </p>

            <p>
             Aethearia draws from that timeless wisdom and roots it in what we now understand about the brain. Our sense of smell is the only sense directly connected to the limbic system — the seat of emotion, memory, and mood. Fragrance bypasses rational thought entirely. It reaches us faster, deeper, and more honestly than almost anything else. The right essential oil, in the right moment, can shift your nervous system from reactive to restored.
            </p>
          </div>

          {/* <div className="about-break">— &nbsp; — &nbsp; —</div> */}

          <div className="about-section">

            <p>
             Every Aethearia candle is handcrafted in small batches — never mass-produced — using premium natural wax blends and IFRA-compliant essential oil compositions, each designed with a specific emotional purpose. Not to simply make your home smell nice, but to help you feel the way you actually want to feel: calm, grounded, clear, comforted, or restored.
            </p>

            <p>
              In a market full of candles that decorate, we make candles that
              work.
            </p>
          </div>

          {/* <div className="about-break">— &nbsp; — &nbsp; —</div> */}

          <div className="about-section about-final">
            {/* <h2>Find your flame.</h2> */}

            <p>
              You do not need to overhaul your life to feel better. You do not need more time, more space, or more effort. You need small, consistent moments of care — a five-minute ritual that tells your nervous system it is safe to exhale.
            </p>

            <p style={{textAlign:"center"}}>That is what Aethearia is here for. Find your flame.</p>

           
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default AboutUs;